const getRequiredRule = msg => {
  return v => !!v || msg;
};

export const msg = {
  username: '請輸入帳號',
  pwd: '請輸入密碼',
  signupUsername: '無效的帳號，請輸入6~16個半形英數',
  signupUsernameHint: '半形英數,不分大小寫',
  signupPwd: '無效的密碼，請輸入6~16個半形英數',
  signupConfirmPwd: '請確認兩次密碼輸入是否相同',
  signupNickname: '請輸入學生姓名',
  signupGender: '請選擇性別',
  signupGrade: '選擇就讀年級',
  signupMobile4parent: '無效的手機號碼',
  email: '您所輸入的電子郵件有誤'
};

// '請輸入帳號'
// '長度限制為6~16個字元'
// '僅可輸入半形英數'

// ============================================================================================

export const username = {
  hint: '',
  errMsg: msg.username,
  rules(msg = this.errMsg) {
    return [getRequiredRule(msg)];
  }
};

export const pwd = {
  hint: '',
  errMsg: msg.pwd,
  rules(msg = this.errMsg) {
    return [getRequiredRule(msg)];
  }
};

export const signupUsername = {
  hint: msg.signupUsernameHint,
  errMsg: msg.signupUsername,
  rules(msg = this.errMsg) {
    return [
      // require
      getRequiredRule(msg),
      // length
      v => (v.length >= 6 && v.length <= 16) || msg,
      // valid characters
      v => {
        const pattern = /[a-zA-Z0-9]+/;
        return pattern.test(v) || msg;
      }
    ];
  }
};

export const signupPwd = {
  hint: '',
  errMsg: msg.signupPwd,
  rules(msg = this.errMsg) {
    return [
      getRequiredRule(msg),
      // length
      v => (v.length >= 6 && v.length <= 16) || msg,
      // valid characters
      v => {
        const pattern = /[a-zA-Z0-9]+/;
        return pattern.test(v) || msg;
      }
    ];
  }
};

export const signupConfirmPwd = {
  hint: '',
  errMsg: msg.signupConfirmPwd,
  rules(msg = this.errMsg) {
    return [getRequiredRule(msg)];
  }
};

export const email = {
  hint: '',
  errMsg: msg.email,
  rules(msg = this.errMsg) {
    return [
      // required
      getRequiredRule(msg),
      // format
      v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // eslint-disable-next-line
        // const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(v) || msg;
      }
    ];
  }
};

export const signupEmail = {
  hint: '',
  errMsg: msg.signupEmail,
  rules: email.rules.bind(email, email.errMsg)
};

export const signupNickname = {
  hint: '',
  errMsg: msg.signupNickname,
  rules(msg = this.errMsg) {
    return [getRequiredRule(msg)];
  }
};

export const signupGender = {
  hint: '',
  errMsg: msg.signupGender,
  rules(msg = this.errMsg) {
    return [getRequiredRule(msg)];
  }
};

export const signupGrade = {
  hint: '',
  errMsg: msg.signupGrade,
  rules(msg = this.errMsg) {
    return [getRequiredRule(msg)];
  }
};

export const signupMobile4parent = {
  hint: '',
  errMsg: msg.signupMobile4parent,
  rules(msg = this.errMsg) {
    return [
      getRequiredRule(msg),
      v => {
        let pattern = /\d{6,10}/;
        return (pattern.test(v) && v.length <= 10) || msg;
      }
    ];
  }
};
